import { Link } from "react-router-dom";
import { ArrowRight, Truck } from "lucide-react";
import { useLang } from "@/context/LangContext";

const SummerBanner = () => {
  const { lang } = useLang();
  const isFr = lang === "fr";
  return (
    <div
      data-testid="summer-banner"
      className="w-full bg-[#3D2B1F] text-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 md:px-16 py-3.5 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-center">
        <span className="inline-flex items-center gap-2 text-[14px] md:text-[15px] font-light leading-snug">
          <Truck size={16} strokeWidth={1.6} />
          {isFr ? (
            <>
              <strong className="font-medium">Coussin Massant Chauffant</strong>
              &nbsp;· Expédié depuis l'Europe (Allemagne) · Livré en 3 à 7 jours ouvrés
            </>
          ) : (
            <>
              <strong className="font-medium">Heated Massage Cushion</strong>
              &nbsp;· Ships from Europe (Germany) · Delivered in 3–7 business days
            </>
          )}
        </span>
        <Link
          to="/product/coussin-massant-chauffant"
          data-testid="summer-banner-cta"
          className="inline-flex items-center gap-2 bg-white text-[#3D2B1F] px-5 py-2 text-[11px] tracking-[0.18em] uppercase font-medium rounded-sm hover:bg-[#F5F0EB] transition-colors"
        >
          {isFr ? "Découvrir le Coussin" : "Discover the Cushion"}
          <ArrowRight size={13} strokeWidth={1.8} />
        </Link>
      </div>
    </div>
  );
};

export default SummerBanner;
